module.exports = __webpack_public_path__ + "img/login-cohete.d45d776a.png";